import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=18a3f7b7&scoped=true"
import script from "./layouts.vue?vue&type=script&lang=js"
export * from "./layouts.vue?vue&type=script&lang=js"
import style0 from "./layouts.vue?vue&type=style&index=0&id=18a3f7b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3f7b7",
  null
  
)

export default component.exports